document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-menu-toggle]');
  if (header && toggle) {
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq__item');
      const open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-product-form-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const sku = root.querySelector('[data-product-sku]');
    const add = root.querySelector('[data-add-button]');
    if (!select || !add) return;
    const refresh = () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (sku && option.dataset.sku) sku.textContent = option.dataset.sku;
      const available = option.dataset.available === 'true';
      add.disabled = !available;
      add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
    };
    select.addEventListener('change', refresh);
    refresh();
  });
});
